module.exports = __webpack_public_path__ + "static/media/main2_en.e3920a2c.png";